module.exports = __webpack_public_path__ + "static/media/category-dark.f9a9a5c4.png";